(function () {
  let executedOnce = false; // ← 初回実行フラグ

  const waitForChannelIO = () => {
    if (typeof ChannelIO === 'function') {
      const plugin = document.getElementById('ch-plugin');
      if (!plugin) {
        setTimeout(waitForChannelIO, 500);
        return;
      }

      // console.log('✅ Channel.io ウィジェット検出済');

      if (!executedOnce) {
        plugin.style.setProperty('z-index', '3', 'important');
        executedOnce = true; // ← 一度実行したらフラグを立てる
      }

      // 表示・非表示時の z-index 切り替え
      ChannelIO('onShow', function () {
        plugin.style.setProperty('z-index', '10', 'important');
      });

      ChannelIO('onHide', function () {
        plugin.style.setProperty('z-index', '3', 'important');
      });
    } else {
      setTimeout(waitForChannelIO, 500);
    }
  };

  waitForChannelIO();
})();